(async () => {
  if (!customElements.get("product-recommendations")) {
    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");
  
    Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector("[data-swiper-recommended-products]");
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          observer: true,
          threshold: 10,
          direction: "horizontal",
          spaceBetween: 16,
          breakpoints: {
            320: {
              slidesPerView: 1.5,
            },
            768: {
              slidesPerView: 2.5,
            },
            1024: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
            1440: {
                slidesPerView: 4.5,
                spaceBetween: 20,
            },
          },
        };

        // Check if we have extra options on the HTML
       
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        window.onload = () => {
          this.init();
        };
      }

      init() {
        if (this.dataset && this.dataset.url) {
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const source = html.querySelector("[data-recommended-products]");
              const target = this.querySelector("[data-recommended-products]");

              if (source && source.innerHTML && source.innerHTML.trim().length) {
                setInnerHTML(target, source.innerHTML);
              }

              this.swiperInstance.update();

              window.dispatchEvent(new Event("recommendationsLoaded"));
            })
            .catch((e) => {
              debug() && console.error(e);
            });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;

    customElements.define("product-recommendations", ProductRecommendations);
  }
})();
